module.exports = __webpack_public_path__ + "assets/60a00328b5159d61dfc3512fefd985cb.svg";